// extracted by mini-css-extract-plugin
export default {"container":"_3BquX","spin":"o7Fvm","absolute":"MU05Y"};